export enum TabItem {
    General = 'General',
    OnlineCheckIn = 'OnlineCheckIn',
    AfterStart = 'AfterStart',
}
